import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input } from '../common/components/formControls';
import validators from '../common/services/validators';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

const LoginForm = ({ error, handleSubmit, pristine, submitting, from, t }) => {

	return (
		<form onSubmit={handleSubmit} className='form-login'>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Field name='username' component={Input} type='text' placeholder={t('FO_Login_Email')} icon='fa fa-user' validate={validators.required} className='form-control redux-field' />
			<Field name='password' component={Input} type='password' placeholder={t('FO_Login_Password')} icon='fa fa-lock' validate={[validators.required]} />
			<div className='form-actions'>
				<div className='auth-link-wrapper'>
					<Link to={`/forgottenPassword`} className='auth-link'>{t('FO_Login_ForgottenPassword')}</Link>
				</div>
				<Button type='submit' disabled={pristine || submitting} className='btn btn-primary btn-auth'>
					{t('FO_Login_Login')} <i className='fa fa-arrow-circle-right' />
				</Button>
				<div className='auth-link-wrapper'>
					<Link to={{ pathname: '/register', state: { from } }} className='auth-link'>{t('FO_Login_NewUser')}</Link>
				</div>
			</div>
		</form>
	);
};

LoginForm.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'login' })(withTranslation()(LoginForm));